module.exports = "<div class=\"instructions-container\">\n  <div class=\"instruction add-pin\">\n    Add marker on the map. <a (click)=\"closeAddPinFlow()\" class=\"action border\"><i class=\"material-icons\">close</i> Cancel</a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/maps-add-stuff/components/add-pin/add-pin.component.html
// module id = ./src/app/modules/maps-add-stuff/components/add-pin/add-pin.component.html
// module chunks = main